module.exports = __webpack_public_path__ + "img/adress_details_blue.729ca1cc.svg";